









helpers = require('../../../../helpers.coffee')

view_model = {
  props: ['notification', 'table']

  data: ->
    current_user: Session.current_user
    go_to: "/contatos/leads?#{@ransack_contact_ids('id_in')}"

  computed:
    text: ->
      if @notification.count > 1
        @notification.count + ' contatos já existentes'
      else
        '1 contato já existente'
}

exports.default = helpers.vue_include(view_model, helpers.notifications.kind_wrapper)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/kind/updated_lead_lovers.vue